import css from "./style.module.css";
import React, { useState, useEffect } from "react";
import { sendData, fetchClientData } from "../../api";
import Pagination from "./pagination";
const Applications = () => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    cabinet: "",
    problem: "",
  });
  const [error, setError] = useState("");
  const [allData, setAllData] = useState([]); // состояние для всех данных из базы данных
  const [currentPage, setCurrentPage] = useState(1); // текущая страница пагинации
  const itemsPerPage = 10; // количество заявок на странице
  useEffect(() => {
    // Загружаем данные при загрузке компонента
    loadData();
  }, []);

  const loadData = async () => {
    const response = await fetchClientData();
    if (response.success) {
      setAllData(response.data);
    } else {
      alert("Ошибка при загрузке данных.");
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.name == "BetX0ven" &&
      formData.number == "73" &&
      formData.cabinet == "874"
    ) {
      setError("asd");
      console.log("asdasdasd");
    } else {
      const response = await sendData(formData);
      if (response.success) {
        alert("Данные успешно отправлены!");
        setFormData({ name: "", number: "", cabinet: "", problem: "" });
        loadData(); // обновляем данные после отправки новой записи
      } else {
        alert("Произошла ошибка при отправке данных.");
      }
    }
  };

  // Определяем диапазон отображаемых заявок для текущей страницы
  const totalPages = Math.ceil(allData.length / itemsPerPage);
  const reversedData = [...allData].reverse(); // Переворачиваем данные
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = reversedData.slice(startIndex, endIndex);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <main className={css.root}>
      <div className="container">
        <div className={css.createRequest}>
          <div className={css.text}>
            <h1> {">"} Создать заявку</h1>
            {/* <h3>
              Оставьте заявку и ждите обратной связи специалиста. <br />
              Либо же осмотрите основные вопросы и разбиритесь с проблемой сами
            </h3> */}
            <h4>Пример:</h4>
            <img src="./example.jpg" alt="" className={css.example} />
          </div>

          <form className={css.form} onSubmit={handleSubmit}>
            <h3>Заявка</h3>
            <input
              name="name"
              type="text"
              placeholder="ФИО учителя"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              name="number"
              type="tel"
              placeholder="Номер телефона"
              value={formData.number}
              onChange={handleChange}
              required
            />
            <input
              name="cabinet"
              type="text"
              placeholder="Номер кабинета"
              value={formData.cabinet}
              onChange={handleChange}
              required
            />

            <h3>Описание проблемы</h3>
            <textarea
              name="problem"
              onChange={handleChange}
              className={css["problem-description"]}
              placeholder="Опишите подробно вашу проблему"
              required
            ></textarea>

            {error && (
              <p>
                <b className={css.secret}>
                  ВОУ!!! Что бы делала гимназия без Ким Виталия? <br />
                  Welcome to my world
                </b>
              </p>
            )}

            <button type="submit">Отправить</button>
          </form>
        </div>
        <div className={css["requests"]}>
          <h1> {">"} Действующие заявки</h1>
          {/* Пагинация */}
          <div className={css.pagination}>
            <Pagination
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
          <ul className={css.application_list}>
            {currentItems.map((data) => (
              <li key={data.id} className={css["application-item"]}>
                <div className={css["requestCard"]}>
                  <div className={css.requestCard__content}>
                    <h2>Заявка</h2>
                    <h3>
                      Номер заявки: <span>{data.id}</span>
                    </h3>
                    <h3>
                      <span>Проблема:</span> <i>{data.problem}</i>
                    </h3>
                    <div className={css["applications-status"]}>
                      <p>
                        Статус:{" "}
                        <span
                          className={
                            css[data.status === "Выполнено" ? "green" : "red"]
                          }
                        >
                          {data.status}
                        </span>{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </main>
  );
};

export default Applications;
